import * as St from './Divider.styles';

interface DividerProps {
  size?: 'small' | 'large';
  m?: [number, number];
  mt?: number;
  mr?: number;
  mb?: number;
  ml?: number;
}

const Divider = ({
  size = 'small',
  m = [8, 0],
  mt,
  mr,
  ml,
  mb,
}: DividerProps) => (
  <St.Container data-size={size} $m={m} $mt={mt} $mr={mr} $mb={mb} $ml={ml} />
);

export default Divider;
